export enum Brand {
  DuerrDental = 'dd',
  AirTechniques = 'at'
}
